/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import store from "./store";

Vue.component("product-lists", () => import("./components/public/productLists"));
Vue.component("product-subcategories", ($category_id) => import("./components/public/productSubcategories"));
Vue.component("product-categories", () => import("./components/public/productCategories"));
Vue.component("product-details", () => import("./components/public/productDetails"));
Vue.component("subscription-product-details", () => import("./components/public/subscriptionProductDetails"));
Vue.component("bucket-lists", () => import("./components/public/carts/bucketLists"));
Vue.component("cart-lists", () => import("./components/public/carts/cartLists"));
Vue.component("checkout-cart", () => import("./components/public/carts/checkoutCart"));
Vue.component("go-to-checkout", () => import("./components/public/carts/GoToCheckout"));
Vue.component("add-interest-product", () => import("./components/public/crm/addInterestProduct"));
Vue.component("homepage-landing", () => import("./components/public/homePage/landing"));
Vue.component("affiliate-register", () => import("./components/public/affiliate/Register"));

const app = new Vue({
    el: '#app',
    store,
    data: {
    },
    computed: {
    }
});
